import { components, MultiValueProps } from 'react-select';

import { CustomSelectProps } from './types';

export const MultiValueWrapper = ({ children, ...props }: MultiValueProps) => {
  const { index, selectProps } = props;
  const { isOverflow, showAllValues, maxVisibleValues } =
    selectProps as CustomSelectProps & typeof selectProps;

  if (
    !maxVisibleValues ||
    !isOverflow ||
    showAllValues ||
    index < maxVisibleValues
  ) {
    return components.MultiValue({ children, ...props });
  }

  return null;
};
